function formatPrice(price) {
  if(price == undefined)
    return "$0,00";
  return "$"+(new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })).format(parseFloat(price))
}

/*
A diferencia de formatPrice, fuerza siempre los 2 decimales: 1500 -> "$ 1.500,00".
Se usa donde el importe se muestra como dato contable (debe/haber).
*/
function formatMoney(value) {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
  }).format(parseFloat(value) || 0);
}

function formatNumber(number) {
  if(number == undefined)
    return "0,00";
  return (new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })).format(parseFloat(number))
}

function formatPriceNumber(price) {  
  return parseFloat(parseFloat(price).toFixed(2));  
}

/*
Normaliza un importe tipeado a mano o pegado desde Excel (formato es-AR) y devuelve un number.
- Con coma: la coma es el separador decimal y los puntos son de miles -> "10.822.496,52" -> 10822496.52
- Sin coma y con 2 o mas puntos: todos los puntos son de miles -> "10.822.496" -> 10822496
- Sin coma y con un solo punto: el punto es el separador decimal -> "1500.50" -> 1500.5
Devuelve null si el valor esta vacio o no representa un numero.
*/
function parseAmount(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number") return isNaN(value) ? null : value;

  //Descarta simbolos de moneda, espacios y cualquier otro caracter que no sea parte del numero
  let clean = String(value).trim().replace(/[^\d.,-]/g, "");
  if (clean === "" || clean === "-") return null;

  const last_comma = clean.lastIndexOf(",");
  const last_dot = clean.lastIndexOf(".");

  if (last_comma >= 0 && last_dot >= 0) {
    //Conviven ambos separadores: el que esta mas a la derecha es el decimal y el otro es de miles
    const decimal_sep = last_comma > last_dot ? "," : ".";
    const thousand_sep = decimal_sep === "," ? /\./g : /,/g;
    clean = clean.replace(thousand_sep, "").replace(decimal_sep, ".");
  } else if (last_comma >= 0) {
    //Solo comas: la ultima es el decimal, las anteriores son de miles
    const parts = clean.split(",");
    const decimals = parts.pop();
    clean = parts.join("") + "." + decimals;
  } else if ((clean.match(/\./g) || []).length > 1) {
    //Varios puntos y ninguna coma: todos son separadores de miles
    clean = clean.replace(/\./g, "");
  }

  const parsed = parseFloat(clean);
  return isNaN(parsed) ? null : parsed;
}

/*
Version string de parseAmount, para reescribir el input una vez normalizado.
Si el texto no es un numero valido lo devuelve sin tocar, asi el usuario ve lo que cargo.
*/
function normalizeAmountInput(value) {
  if (value === null || value === undefined || value === "") return value;

  const parsed = parseAmount(value);
  return parsed === null ? value : String(parsed);
}

function formatDateString(date_string) {
  //Format "yyyy-mm-dd" to "dd/mm/yyyy"
  if(date_string === null) return "-";
  
  const [year, month, day] = date_string.split('-');
  
  const dayFormatted = day.padStart(2, '0');
  const monthFormatted = month.padStart(2, '0');
  
  return `${dayFormatted}/${monthFormatted}/${year}`;  
}

/*
Si el comprobante no es en mon_id PES, entonces se convierte el valora mostrar segun mon_cotiz
*/
function formatValueByCurrency(value, comprobante) {  
  console.log("formatValueByCurrency", value, comprobante);
  if(comprobante.mon_id === "PES") {
    return value;
  } else {
    return parseFloat(parseFloat(value / comprobante.mon_cotiz).toFixed(2));
  }
}

function formatDateTimeString(datetime_string) {
  if (!datetime_string) return '-';
  const [date, time] = datetime_string.split(' ');
  if (!date) return '-';
  const formatted_date = formatDateString(date);
  if (!time) return formatted_date;
  return `${formatted_date} ${time.substring(0, 5)}`;
}

export const formatUtils = {
  parseAmount,
  normalizeAmountInput,
  formatPrice,
  formatMoney,
  formatNumber,
  formatPriceNumber,
  formatDateString,
  formatDateTimeString,
  formatValueByCurrency
};
